export default __webpack_public_path__ + "static/media/proj2.a73731e4.png";